import { setUserDetails } from "../../reducers/userDetails"
import store from "../../store"

const SetUserDetailsAction = (data: any) => {
    store.dispatch(setUserDetails(data))
}
export default SetUserDetailsAction